import { TooltipPosition } from "../TooltipContent.types";

export const getCurrentPosition = (
  content: HTMLDivElement,
  position: TooltipPosition,
  autoPosition: boolean
): TooltipPosition => {
  if (!autoPosition) {
    return position;
  }

  const { top, right, bottom, left } = content.getBoundingClientRect();
  const isTopPosition =
    position !== TooltipPosition.Bottom && bottom <= window.innerHeight && top >= 0;
  const isRightPosition = left < 0;
  const isLeftPosition = right > window.innerWidth;

  if (isRightPosition) {
    return isTopPosition ? TooltipPosition.TopStart : TooltipPosition.BottomStart;
  }

  if (isLeftPosition) {
    return isTopPosition ? TooltipPosition.TopEnd : TooltipPosition.BottomEnd;
  }

  return isTopPosition ? TooltipPosition.Top : TooltipPosition.Bottom;
};
